const CONSTANTS = {

    FOOTER_TELL_US_URL: "https://feedback.employeehub.autodesk.com",

    EMPLOYEE_HUB_SLACK_URL: "https://autodesk.slack.com/app_redirect?channel=CN0BF89H9",
    
    NOTIFICATION_BANNER_TEXT: '<b>Update:</b> Change and reset password now share the same experience',

    RESET_PASSWORD_DESC_TEXT: "For your security, if you forgot or need to change your password to access Autodesk systems again, follow the steps below.",
    
    PASSWORD_RESET_STEPS: [
        'Check that you have <b>Microsoft Authenticator installed</b> on your mobile device.',
        'Go to the <a id="authenticator-link" target="_blank" href="https://passwordreset.microsoftonline.com/">Microsoft Online Password Reset page</a> and follow the prompts.',
        "Make sure your new password follows the requirements below."
    ],
    
    PASSWORD_REQUIREMENTS: [
        "Uppercase letters (A through Z)",
        "Lowercase letters (a through z)",
        "Numbers (0 through 9)",
        'Special characters (~!@#$%^&*_-+=`|(){}[]:;""<>,.?/)'
    ],
    
    PASSWORD_EVALUATION_PATTERNS: [
        "Weak passwords (e.g. 'Password123456!')",
        "Known weak passwords (e.g. 'Changeme123456!' or 'Contoso!123456')",
        "Autodesk company name or product names within the password (e.g. 'Autodesk101010!' or '@ut0desk123456')",
        "Compromised passwords that were publicly published in a previous data breach"
    ],

};

export default CONSTANTS;